module.exports = __webpack_public_path__ + "static/media/lightbulb_7.99b2f6b3.png";